/* eslint-disable camelcase */
/* eslint-disable no-mixed-operators */
import React from 'react';
import Routes from 'config/routes';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from 'react-intl';
import { toast } from 'react-toastify';
import messages from './messages';
import {
  Grid,
  Header,
  Divider,
  Segment,
  Button,
  Checkbox,
  Form,
  Input,
  List,
  Popup,
  Icon,
} from 'semantic-ui-react';
import _ from 'lodash';

const kgrams = [
  { key: '0', text: '0', value: 0 },
  { key: '1', text: '1', value: 1 },
  { key: '2', text: '2', value: 2 },
  { key: '3', text: '3', value: 3 },
  { key: '4', text: '4', value: 4 },
  { key: '5', text: '5', value: 5 },
  { key: '6', text: '6', value: 6 },
  { key: '7', text: '7', value: 7 },
  { key: '8', text: '8', value: 8 },
  { key: '9', text: '9', value: 9 },
  { key: '10', text: '10', value: 10 },
  { key: '11', text: '11', value: 11 },
  { key: '12', text: '12', value: 12 },
  { key: '13', text: '13', value: 13 },
  { key: '14', text: '14', value: 14 },
  { key: '15', text: '15', value: 15 },
  { key: '16', text: '16', value: 16 },
  { key: '17', text: '17', value: 17 },
  { key: '18', text: '18', value: 18 },
  { key: '19', text: '19', value: 19 },
  { key: '20', text: '20', value: 20 },
  { key: '21', text: '21', value: 21 },
  { key: '22', text: '22', value: 22 },
  { key: '23', text: '23', value: 23 },
  { key: '24', text: '24', value: 24 },
  { key: '25', text: '25', value: 25 },
];

const grams = [
  { key: '0', text: '0', value: 0 },
  { key: '100', text: '100', value: 100 },
  { key: '200', text: '200', value: 200 },
  { key: '300', text: '300', value: 300 },
  { key: '400', text: '400', value: 400 },
  { key: '500', text: '500', value: 500 },
  { key: '600', text: '600', value: 600 },
  { key: '700', text: '700', value: 700 },
  { key: '800', text: '800', value: 800 },
  { key: '900', text: '900', value: 900 },
];

class LegacyCalculator extends React.Component {
  state = {
    loading: true,
    iso_code: this.props.iso_code,
    customsCategoryID: null,
    itemStorePrice: null,
    weightKG: 0,
    weightGram: 100,
    couponCode: '',
    findMaxDiscount: false,
    storePriceUsd: '-',
    fees: '-',
    shippingIntl: '-',
    customs: '-',
    customsRate: -1,
    clearanceCharges: '-',
    subtotal: '-',
    vat: '-',
    promotionDiscount: 0,
    totalPrice: '-',
    currencyCode: '-',
    usdSign: '-',
    customsCategories: [],
    exchangeRate: 0,
    promotionHandlerMessage: '',
  };

  componentWillReceiveProps(np) {
    if (
      np.activeCustomsCategories.active_customs_categories &&
      !this.state.customsCategories.length
    ) {
      const mapped_customs_categories =
        np.activeCustomsCategories.active_customs_categories.map(
          (customs_category) => ({
            key: customs_category.id,
            text: this.props.intl.locale === 'ar' ? customs_category.name_ar : customs_category.name,
            value: customs_category.id,
          })
        );

      this.setState({
        customsCategories: mapped_customs_categories,
        loading: false,
      });
    }
  }

  goToCart = () => {
    window.location = Routes.Cart;
  };

  handleFormSubmit = async () => {
    this.setState({ loading: true });
    if (!this.state.customsCategoryID) {
      toast.error(
        <div>
          <b>Error</b>, Please choose the customs category first.
        </div>
      );

      return;
    }

    if (!this.state.itemStorePrice) {
      toast.error(
        <div>
          <b>Error</b>, Please enter a valid store price.
        </div>
      );

      return;
    }
    const result = await this.props.calculateItem({
      errorPolicy: 'all',
      variables: {
        customs_category_id: parseInt(this.state.customsCategoryID),
        store_price_usd: parseFloat(this.state.itemStorePrice),
        weight_kg: parseFloat(this.state.weightKG),
        weight_gram: parseFloat(this.state.weightGram),
        coupon_code: this.state.couponCode,
        find_max_discount: this.state.findMaxDiscount,
      },
    });

    if (result.errors && result.errors.length) {
      this.setState({ formErrors: [result.errors[0].message] });
      toast.error(
        <div>
          <b>Error</b>, {result.errors[0].message}.
        </div>
      );
    } else if (result.data.calculateItem) {
      this.setState({
        loading: false,
        usdSign: '$',
        storePriceUsd: _.round(result.data.calculateItem.store_price_usd, 2),
        fees: _.round(result.data.calculateItem.fees, 2),
        shippingIntl: _.round(result.data.calculateItem.shipping_intl, 2),
        customs: _.round(result.data.calculateItem.customs, 2),
        customsRate: _.round(result.data.calculateItem.customs_rate, 2),
        clearanceCharges: _.round(
          result.data.calculateItem.clearance_charges,
          2
        ),
        exchangeRate: result.data.calculateItem.exchange_rate_value,
        subtotal: _.round(result.data.calculateItem.subtotal, 2),
        vat: _.round(result.data.calculateItem.vat, 2),
        currencyCode: result.data.calculateItem.currency_code,
        promotionDiscount: _.round(
          result.data.calculateItem.promotion_discount,
          2
        ),
        totalPrice: _.round(result.data.calculateItem.total_price, 2),
        promotionHandlerMessage:
          this.props.intl.locale === 'ar' ?
            result.data.calculateItem.promo_message_ar :
            result.data.calculateItem.promo_message,
        couponCode: result.data.calculateItem.coupon_code,
      });
    }
  };

  render() {
    const {
      customsCategoryID,
      itemStorePrice,
      weightKG,
      weightGram,
      couponCode,
    } = this.state;

    return (
      <Grid stackable centered dir={`${this.props.intl.locale === 'ar' ? 'rtl' : 'ltr'}`}>
        <Grid.Column width={8}>
          <Form>
            <Form.Group widths="equal">
              <Form.Select
                fluid
                label={this.props.intl.formatMessage({ ...messages.category })}
                options={this.state.customsCategories}
                value={customsCategoryID}
                onChange={(e, data) =>
                  this.setState({ customsCategoryID: data.value })
                }
              />
            </Form.Group>

            <Form.Field>
              <label className="pullLeft" htmlFor="presentation">
                <FormattedMessage {...messages.storePrice} />
              </label>
              <Input
                type="number"
                step="0.1"
                min="0"
                value={itemStorePrice}
                onChange={(e) =>
                  this.setState({ itemStorePrice: e.target.value })
                }
              />
            </Form.Field>

            <Form.Group widths="equal">
              <Form.Select
                fluid
                label={this.props.intl.formatMessage({ ...messages.weightKG })}
                options={kgrams}
                value={weightKG}
                onChange={(e, data) => this.setState({ weightKG: data.value })}
              />
              <Form.Select
                fluid
                label={this.props.intl.formatMessage({ ...messages.weightGram })}
                options={grams}
                value={weightGram}
                onChange={(e, data) =>
                  this.setState({ weightGram: data.value })
                }
              />
            </Form.Group>

            <Form.Field>
              <label className="pullLeft" htmlFor="presentation">
                <FormattedMessage {...messages.couponCode} />
              </label>
              <Input
                type="string"
                step="0.1"
                min="0"
                disabled={this.state.findMaxDiscount}
                value={couponCode}
                onChange={(e) => this.setState({ couponCode: e.target.value })}
              />
              <Checkbox
                label={this.props.intl.formatMessage({ ...messages.pickForMe })}
                style={{ marginTop: '3px' }}
                checked={this.state.findMaxDiscount}
                onChange={() =>
                  this.setState({
                    findMaxDiscount: !this.state.findMaxDiscount,
                  })
                }
              />
            </Form.Field>
            <Form.Field>
              <Button
                onClick={() => this.handleFormSubmit()}
                basic
                primary
                size="large"
              >
                <FormattedMessage {...messages.calculate} />
              </Button>
            </Form.Field>
          </Form>
        </Grid.Column>

        {this.state.totalPrice > 0 && <Grid.Column width={8}>
          {/* <Header>Item Cost</Header> */}
          <Segment>
            <List dir={`${this.props.intl.locale === 'ar' ? 'rtl' : 'ltr'}`}>
              <List.Item>
                <List.Content className="pullLeft" lang={this.props.intl.locale}>
                  <FormattedMessage {...messages.storePrice} />
                </List.Content>
                {this.state.storePriceUsd > 0 && <List.Content className="pullRight" lang={this.props.intl.locale}>
                  {localizeNumber(this.props.intl.locale, _.round(this.state.storePriceUsd, 2))} {localizeCurrency(this.props.intl.locale, 'usd')}
                </List.Content>}
              </List.Item>

              <List.Item>
                <List.Content className="pullLeft" lang={this.props.intl.locale}>
                  <FormattedMessage {...messages.intlShipping} />
                </List.Content>
                {this.state.shippingIntl > 0 && <List.Content className="pullRight" lang={this.props.intl.locale}>
                  {localizeNumber(this.props.intl.locale, _.round(this.state.shippingIntl, 2))} {localizeCurrency(this.props.intl.locale, 'usd')}
                </List.Content>}
              </List.Item>

              <List.Item>
                <List.Content className="pullLeft" lang={this.props.intl.locale}>
                  <FormattedMessage {...messages.serviceFees} />
                  {this.state.iso_code === 'EG' && this.state.fees !== '-' && (
                    <Popup
                      trigger={<Icon link name="info circle" />}
                      content={this.props.intl.formatMessage({ ...messages.serviceFeesHint })}
                      position="top center"
                    />
                  )}
                </List.Content>
                {this.state.fees > 0 && <List.Content className="pullRight" lang={this.props.intl.locale}>
                  {localizeNumber(this.props.intl.locale, _.round(this.state.fees, 2))} {localizeCurrency(this.props.intl.locale, 'usd')}
                </List.Content>}
              </List.Item>

              {this.state.customs > 0 && (
                <List.Item>
                  <List.Content className="pullLeft" lang={this.props.intl.locale}>
                    <FormattedMessage {...messages.customs} />
                    {/*this.state.customsRate > 0 && (
                      <Popup
                        trigger={<Icon link name="info circle" />}
                        content={`${this.state.customsRate}% of the item price, charged by customs authorities.`}
                        position="top center"
                      />
                    )*/}
                  </List.Content>
                  {this.state.customs > 0 && <List.Content className="pullRight" lang={this.props.intl.locale}>
                    {localizeNumber(this.props.intl.locale, _.round(this.state.customs, 2))} {localizeCurrency(this.props.intl.locale, 'usd')}
                  </List.Content>}
                </List.Item>
              )}

              {this.state.clearanceCharges > 0 && (
                <List.Item>
                  <List.Content className="pullLeft" lang={this.props.intl.locale}>
                    <FormattedMessage {...messages.clearance} />
                    <Popup
                      trigger={<Icon link name="info circle" />}
                      content={this.props.intl.formatMessage({ ...messages.clearanceHint })}
                      position="top center"
                    />
                  </List.Content>
                  <List.Content className="pullRight" lang={this.props.intl.locale}>
                    {localizeNumber(this.props.intl.locale, _.round(this.state.clearanceCharges, 2))} {localizeCurrency(this.props.intl.locale, 'usd')}
                  </List.Content>
                </List.Item>
              )}

              {this.state.promotionDiscount < 0 && (
                <List.Item>
                  <List.Content className="pullLeft" lang={this.props.intl.locale}>
                    <FormattedMessage {...messages.discount} />
                    <Popup
                      dir={`${this.props.intl.locale === 'ar' ? 'rtl' : 'ltr'}`}
                      trigger={<Icon link name="info circle" />}
                      content={this.props.intl.formatMessage({ ...messages.useCode }, {code: this.state.couponCode})}
                      position="top center"
                    />
                  </List.Content>
                  <List.Content
                    className="pullRight"
                    lang={this.props.intl.locale}
                    style={{ color: '#B12704', fontWeight: 'bold' }}
                  >
                    {localizeNumber(this.props.intl.locale, _.round(this.state.promotionDiscount, 2))} {localizeCurrency(this.props.intl.locale, 'usd')}
                  </List.Content>
                </List.Item>
              )}

              <Divider />

              <List.Item>
                <List.Content>
                  <div className="pullLeft" lang={this.props.intl.locale}>
                    <FormattedMessage {...messages.subtotal} />
                  </div>
                  <br />
                  {this.state.exchangeRate > 0 && (
                    <div style={{ fontSize: '11px' }} className="pullLeft" lang={this.props.intl.locale}>
                      <FormattedMessage {...messages.exchangeRate} />
                      <b style={{ color: '#B12704' }}>
                        {localizeNumber(this.props.intl.locale, _.round(this.state.exchangeRate, 2))} {localizeCurrency(this.props.intl.locale, this.state.currencyCode)}
                      </b>
                    </div>
                  )}
                </List.Content>
                {this.state.subtotal > 0 && <List.Content className="pullRight"  lang={this.props.intl.locale}>
                  {localizeNumber(this.props.intl.locale, _.round(this.state.subtotal, 2))} {localizeCurrency(this.props.intl.locale, this.state.currencyCode)}
                </List.Content>}
              </List.Item>

              <List.Item>
                <List.Content className="pullLeft" lang={this.props.intl.locale}><FormattedMessage {...messages.vat} /></List.Content>
                {this.state.vat > 0 && <List.Content className="pullRight" lang={this.props.intl.locale}>
                  {localizeNumber(this.props.intl.locale, _.round(this.state.vat, 2))} {localizeCurrency(this.props.intl.locale, this.state.currencyCode)}
                </List.Content>}
              </List.Item>

              <Divider />

              <List.Item>
                <List.Content className="pullLeft" lang={this.props.intl.locale}>
                  <b><FormattedMessage {...messages.total} /></b>
                </List.Content>
                {this.state.totalPrice > 0 && <List.Content className="pullRight" lang={this.props.intl.locale}>
                  <Header size="small" style={{ color: '#B12704' }}>
                    {localizeNumber(this.props.intl.locale, _.round(this.state.totalPrice, 2))} {localizeCurrency(this.props.intl.locale, this.state.currencyCode)}
                  </Header>
                </List.Content>}
              </List.Item>
            </List>
          </Segment>
        </Grid.Column>}
        {this.state.promotionHandlerMessage && (
          <Grid.Column width={16}>
            <label dir={`${this.props.intl.locale === 'ar' ? 'rtl' : 'ltr'}`} className="pullLeft" htmlFor="presentation" lang={this.props.intl.locale}>
              {this.state.promotionHandlerMessage}
            </label>
          </Grid.Column>
        )}
        {this.state.promotionHandlerMessage &&
          this.state.promotionDiscount < 0 && (
            <Grid.Column width={8} centered>
              <Button
                onClick={() => this.goToCart()}
                fluid
                style={{ justifyContent: 'center' }}
                color="orange"
              >
                <FormattedMessage {...messages.placeOrder} />
              </Button>
            </Grid.Column>
          )}
      </Grid>
    );
  }
}

const ITEM_CALCULATOR_MUTATION = gql`
  mutation calculateItem(
    $customs_category_id: ID!
    $store_price_usd: Float!
    $weight_kg: Float!
    $weight_gram: Float!
    $coupon_code: String
    $find_max_discount: Boolean
  ) {
    calculateItem(
      customs_category_id: $customs_category_id
      store_price_usd: $store_price_usd
      weight_kg: $weight_kg
      weight_gram: $weight_gram
      coupon_code: $coupon_code
      find_max_discount: $find_max_discount
    ) {
      store_price_usd
      fees
      shipping_intl
      customs
      customs_rate
      clearance_charges
      exchange_rate_value
      subtotal
      vat
      promotion_discount
      total_price
      currency_code
      coupon_code
      promo_message
      promo_message_ar
    }
  }
`;

const ACTIVE_CUSTOMS_CATEGORIES = gql`
  query ($iso_code: String!) {
    active_customs_categories(iso_code: $iso_code) {
      id
      name
      name_ar
    }
  }
`;

export default compose(
  injectIntl,
  graphql(ITEM_CALCULATOR_MUTATION, {
    name: 'calculateItem',
  }),
  graphql(ACTIVE_CUSTOMS_CATEGORIES, {
    name: 'activeCustomsCategories',
    options: {
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
    },
  })
)(LegacyCalculator);



// WEBPACK FOOTER //
// ./app/components/CalculatorModal/LegacyCalculator.js